"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDatePickerContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n\n  &,\n  & input {\n    font-family: ", ";\n    font-weight: 400 !important;\n    box-sizing: border-box;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledDatePickerContainer = _styledComponents.default.div(_templateObject(), function (props) {
  return props.theme.type.avenirFamily;
});

exports.StyledDatePickerContainer = StyledDatePickerContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/calcite-react/DatePicker/DatePicker-styled.js
// module id = 626
// module chunks = 0